/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../$$_gendir/node_modules/@angular/material/sidenav/typings/index.ngfactory';
import * as i2 from '@angular/material/core';
import * as i3 from '@angular/material/sidenav';
import * as i4 from '@angular/cdk/bidi';
import * as i5 from '@angular/router';
import * as i6 from '../../../../app/layouts/auth/auth-layout.component';
const styles_AuthLayoutComponent:any[] = ['[_nghost-%COMP%]     .mat-drawer-content {padding: 0;} .mat-drawer-container[_ngcontent-%COMP%] {z-index: 1000}'];
export const RenderType_AuthLayoutComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_AuthLayoutComponent,data:{}});
export function View_AuthLayoutComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'mat-sidenav-container',
      [['class','mat-drawer-container mat-sidenav-container']],(null as any),(null as any),
      (null as any),i1.View_MatSidenavContainer_0,i1.RenderType_MatSidenavContainer)),
      i0.ɵdid(16384,(null as any),0,i2.MatPrefixRejector,([] as any[]),(null as any),
          (null as any)),i0.ɵdid(1228800,(null as any),2,i3.MatSidenavContainer,[[2,
          i4.Directionality],i0.ElementRef,i0.Renderer2,i0.NgZone,i0.ChangeDetectorRef],
          (null as any),(null as any)),i0.ɵqud(603979776,1,{_drawers:1}),i0.ɵqud(335544320,
          2,{_content:0}),(_l()(),i0.ɵted(2,['\n  '])),(_l()(),i0.ɵeld(16777216,(null as any),
          2,1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i5.RouterOutlet,
          [i5.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i0.ɵted(2,['\n']))],(_ck,_v) => {
    _ck(_v,7,0);
  },(null as any));
}
export function View_AuthLayoutComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-layout',([] as any[]),
      (null as any),(null as any),(null as any),View_AuthLayoutComponent_0,RenderType_AuthLayoutComponent)),
      i0.ɵdid(49152,(null as any),0,i6.AuthLayoutComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AuthLayoutComponentNgFactory:i0.ComponentFactory<i6.AuthLayoutComponent> = i0.ɵccf('app-layout',
    i6.AuthLayoutComponent,View_AuthLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvbGF5b3V0cy9hdXRoL2F1dGgtbGF5b3V0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvY2hyb25vY2FzaFYzL3Rlc3Qvd2ViYXBwLWNsay9zcmMvYXBwL2xheW91dHMvYXV0aC9hdXRoLWxheW91dC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvY2hyb25vY2FzaFYzL3Rlc3Qvd2ViYXBwLWNsay9zcmMvYXBwL2xheW91dHMvYXV0aC9hdXRoLWxheW91dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvbGF5b3V0cy9hdXRoL2F1dGgtbGF5b3V0LmNvbXBvbmVudC50cy5BdXRoTGF5b3V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG1hdC1zaWRlbmF2LWNvbnRhaW5lcj5cbiAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuPC9tYXQtc2lkZW5hdi1jb250YWluZXI+IiwiPGFwcC1sYXlvdXQ+PC9hcHAtbGF5b3V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBO2FBQUE7VUFBQSxzQkFBQTsyQkFBQTtVQUFBO1VBQUEsZ0JBQXVCLDZCQUNyQjtVQUFBO1VBQUEscUNBQUE7VUFBQTtjQUFBO01BQStCO0lBQS9COzs7O29CQ0RGO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layouts/auth/auth-layout.component.ngfactory.ts